export default {
	CANCEL: -1,
	SAVE: 1,
	FILTER: 2,
};
